import React from 'react'
import { Box, Anchor } from '@mantine/core'
import { AppBadge } from '../../app/common/ui'
import { AppText } from '../../app/common/ui'
import type { CartridgeSpecFormValues } from '../../app/models/ammo'

export interface CartridgePreviewCardProps {
  specForm: CartridgeSpecFormValues
  matchedCartridgeSpecId: string | null
  matchedSpecLabel: string | null
  onEditCartridge: () => void
}

export default function CartridgePreviewCard ({
  specForm,
  matchedCartridgeSpecId,
  matchedSpecLabel,
  onEditCartridge
}: CartridgePreviewCardProps) {
  const isMatched = Boolean(matchedCartridgeSpecId)

  return (
    <Box
      data-testid="cartridge-preview-card"
      sx={{
        padding: '14px var(--gs-md)',
        borderRadius: '6px',
        border: '1px solid var(--gs-ammo-border)',
        background: 'var(--gs-surface2)',
        marginBottom: 'var(--gs-sm)'
      }}
    >
      <AppText size="xs" weight={600} sx={{ color: 'var(--gs-muted)', marginBottom: 'var(--gs-sm)', textTransform: 'uppercase', letterSpacing: 0.5 }}>
        Cartridge
      </AppText>
      <AppText weight={700} size="sm" sx={{ marginBottom: 'var(--gs-xs)' }}>
        {specForm.name || '—'}
      </AppText>
      <AppText size="xs" sx={{ color: 'var(--gs-muted)', fontFamily: 'JetBrains Mono, monospace', marginBottom: 'var(--gs-sm)' }}>
        {specForm.shortName ? `${specForm.shortName} · ` : ''}{specForm.caliber || '—'} · {specForm.type}
      </AppText>
      <AppBadge
        size="sm"
        variant="outline"
        sx={{
          borderColor: isMatched ? 'var(--gs-gold)' : 'var(--gs-border)',
          color: isMatched ? 'var(--gs-gold)' : 'var(--gs-muted)'
        }}
      >
        {isMatched
          ? `Matches existing: ${matchedSpecLabel ?? 'catalog entry'}`
          : 'This is a new cartridge entry'}
      </AppBadge>
      <Box sx={{ marginTop: 'var(--gs-sm)' }}>
        <Anchor component="button" type="button" size="xs" onClick={onEditCartridge}>
          Edit cartridge
        </Anchor>
      </Box>
    </Box>
  )
}
